module.exports = __webpack_public_path__ + "static/Narendra_Pashuparthy-d9c7404e4021067cea3554ebb8aabc90.jpg";